import { useRouterHistory } from 'react-router'
import { createHistory } from 'history'

export let history = useRouterHistory(createHistory)({
  basename: process.env.REACT_APP_URL_PATH
})


// WEBPACK FOOTER //
// ./src/history.js